/* eslint-disable */
// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";


const initialUser = () => {
  const item = window.localStorage.getItem("userData");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    user: initialUser(),
  },
  reducers: {
    handleLogin: (state, action) => {
      state.user = action.payload
       console.log(action.payload,'what is thsi')

      //state[config.storageTokenKeyName] =
       // action.payload[config.storageTokenKeyName];

       localStorage.setItem("userData", JSON.stringify(action.payload));
      // localStorage.setItem(
      //   config.storageTokenKeyName,
      //   JSON.stringify(action.payload.accessToken)
      // );
    },
    handleLogout: (state) => {
      state.user = null
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
      localStorage.removeItem("refreshToken")
    },
  },
});

export const { handleLogin, handleLogout } = authSlice.actions;

export default authSlice.reducer;
